const ProductImageFormat = {
  CART_ICON: Symbol.for('cartIcon'),
  MOBILE_PRODUCT_LISTING_IMAGE: Symbol.for('mobileProductListingImage'),
  PRODUCT: Symbol.for('product'),
  THUMNAIL: Symbol.for('thumbnail')
};
export default ProductImageFormat;
